import { isStringDirty } from "@suse-o11y/is-string-dirty";
import { FormShape, FormUnit } from "@suse-o11y/signal/form";
import { z } from "zod";

export interface InitParams {
	name: string;
	description?: string;
	identifier?: string;
}

export function init({ name, description = "", identifier = "" }: InitParams) {
	return FormShape({
		name: FormUnit(name, {
			schema: z.string().trim().min(1, "View name is required"),
			isInputDirty: isStringDirty,
		}),

		description: FormUnit(description, {
			isInputDirty: isStringDirty,
			schema: z
				.string()
				.max(500, "View description cannot exceed 500 characters")
				.trim()
				.transform((output) => output || undefined),
		}),

		identifier: FormUnit(identifier, {
			isInputDirty: isStringDirty,
			transform: (input) => input.trim() || undefined,
		}),
	});
}

export type FormState = ReturnType<typeof init>;
